import { Injectable } from '@angular/core';
import { ApiCacheOptions } from '../../../shared/api/api-cache-options.model';
import { PaymentMethodFeeType } from './payment-method-fee-type.model';
import { EventPaymentMethod } from './event-payment-method.model';
import { TranslationService } from '../../../shared/translation/translation.service';
import { IEventV4PaymentMethodService } from './ievent-v4-payment-method.service';
import { EventsServiceApiService } from 'src/app/shared/api/events-service-api.service';

@Injectable({
  providedIn: 'root',
})
export class EventV4PaymentMethodService implements IEventV4PaymentMethodService {
  private _eventServiceBaseUrl: string = '/event/v2/paymentmethod/';

  public constructor(private _translationService: TranslationService, private _eventApiService: EventsServiceApiService) {}

  public getEventPaymentMethods = (eventId: number): Promise<Array<EventPaymentMethod>> => {
    let url: string = `${this._eventServiceBaseUrl}event/${eventId.toString()}/event-payment-methods`;
    let options: ApiCacheOptions = new ApiCacheOptions();
    options.DisableCaching = true;
    return this._eventApiService.get(url, options).then((paymentMethods: Array<EventPaymentMethod>) => {
      if (!paymentMethods) return paymentMethods;

      // get translations for payment method types
      // language agnostic
      let translatePromises = paymentMethods.map((pMethod) => {
        let translationKey: string = '';

        switch (pMethod.PaymentMethodId) {
          case 1:
            translationKey = 'enum.payment-method-type.bill-later';
            break;
          case 2:
            translationKey = 'enum.payment-method-type.pay-at-door';
            break;
          case 3:
            translationKey = 'enum.payment-method-type.credit-card';
            break;
          case 4:
            translationKey = 'enum.payment-method-type.purchase-order';
            break;
          case 5:
            translationKey = 'enum.payment-method-type.cash-check';
            break;
        }

        if (translationKey)
          return this._translationService.getTitlecase(translationKey).then((translation) => (pMethod.Descr = translation));
        else return Promise.resolve('');
      });

      // return the paymentmethods as a promise after getting the translations
      return Promise.all(translatePromises).then(() => paymentMethods);
    });
  };

  public getEventPaymentMethod = (eventPaymentMethodId: number): Promise<EventPaymentMethod> => {
    let url: string = `${this._eventServiceBaseUrl}${eventPaymentMethodId.toString()}`;
    let options: ApiCacheOptions = new ApiCacheOptions();
    options.DisableCaching = true;
    return this._eventApiService.get(url, options);
  };

  public getPaymentMethodFeeTypes = (): Array<PaymentMethodFeeType> => {
    let feeType1: PaymentMethodFeeType = new PaymentMethodFeeType();
    let feeType2: PaymentMethodFeeType = new PaymentMethodFeeType();

    feeType1.FeeType = 'Flat Fee';
    feeType1.FeeTypeId = 0;

    feeType2.FeeType = 'Percent';
    feeType2.FeeTypeId = 1;

    let results: Array<PaymentMethodFeeType> = new Array<PaymentMethodFeeType>();

    results.push(feeType1);
    results.push(feeType2);

    return results;
  };

  public upsertEventPaymentMethod = (eventPaymentMethod: EventPaymentMethod): Promise<any> => {
    return this._eventApiService.post(this._eventServiceBaseUrl, eventPaymentMethod).then((data: any) => {
      eventPaymentMethod.EventPaymentMethodId = data;
    });
  };

  public updateEventPaymentMethodAccepted = (eventId: number, paymentMethodId: number, isAccepted: boolean): void => {
    let url: string = `${
      this._eventServiceBaseUrl
    }event/${eventId.toString()}/payment-method/${paymentMethodId.toString()}/accepted/${isAccepted.toString()}`;
    this._eventApiService.put(url, null);
  };
}
